module.exports = __webpack_public_path__ + "static/media/new-activity.97764a8c.svg";